import { boundedNativeStore } from './native-string-store';
import { Storage } from '@apps-in-toss/web-framework';
import { platform } from './adapter';
import { RecoveryController } from '../persistence/recovery-controller';
import { deleteAllLocalData, readRecoverySource, restoreRecoverySource } from '../persistence/db';
import { onLocalDataChanged } from '../persistence/local-data-events';
import type { RecoveryEnvironment } from '../persistence/recovery-copy';

export function recoveryEnvironment(hostname: string): RecoveryEnvironment | null {
  if (hostname === 'carryonpan.apps.tossmini.com') return 'public';
  if (hostname === 'carryonpan.private-apps.tossmini.com') return 'private';
  if (hostname === 'carryonpan.web.tossmini.com') return 'legacy';
  if (import.meta.env.MODE === 'toss' && ['localhost', '127.0.0.1'].includes(hostname)) return 'local-test';
  return null;
}
const environment = recoveryEnvironment(location.hostname);
export const nativeRecovery = platform.channel === 'apps_in_toss' && environment ? new RecoveryController({ storage: boundedNativeStore(Storage), environment, readSource: readRecoverySource, restore: restoreRecoverySource, deleteSource: deleteAllLocalData }) : null;
export function installTossRecovery() {
  if (!nativeRecovery) return () => undefined;
  const controller = nativeRecovery;
  void controller.inspect();
  const off = onLocalDataChanged(() => { void controller.sourceChanged(); });
  const resume = () => { if (document.visibilityState === 'visible') void controller.inspect(); };
  document.addEventListener('visibilitychange', resume);
  return () => { off(); document.removeEventListener('visibilitychange', resume); };
}
